import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome, WithTeam } from '~/core/styleTypes';

import { getEntityBackgroundColor, getEntityTextAndBorderColor } from '../../../../utils';

export const PlayerDiv = styled.div<WithTeam & WithIsHome>`
    ${BaseStyle.Mixins.fontStyles.ui['12b']};
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid ${({ theme, $isHome, $teamAbbrev }) => getEntityTextAndBorderColor(theme, $isHome, $teamAbbrev)};
    text-align: center;
    display: grid;
    align-content: center;
    background: ${({ theme, $isHome, $teamAbbrev }) => getEntityBackgroundColor(theme, $isHome, $teamAbbrev)};
    color: ${({ theme, $isHome, $teamAbbrev }) => getEntityTextAndBorderColor(theme, $isHome, $teamAbbrev)};

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['10b']};
        width: 24px;
        height: 24px;
    }
`;

export const PlayerMarkerContainer = styled.div`
    position: relative;
    margin: 0 2px;
`;
